export class ContactPerson{
    title: string | null
    firstName: string | null
    lastName: string | null
    designation: string | null
}